<template>
  <div class="firmlogin">
    <!-- <img class="firmbg" src="https://tkdlapp.zhsq.cloud/img/firmlogin.243bfc50.png" alt="" /> -->
    <!-- 登录 -->
    <div class="logintopss" v-if="loginindex">
      <div style="font-size: 18px; color: #000; margin-top: 10px"></div>
      <div>
        <div class="loginTitle">手机号</div>
        <input type="text" v-model="loginfrom.phone" placeholder="输入手机号" />
        <div class="loginTitle">密码</div>
        <input
          type="password"
          v-model="loginfrom.password"
          placeholder="输入密码"
        />
      </div>
      <div>
        <van-button class="loginbutton" round type="info" @click="login()"
          >登 录</van-button
        >
        <!-- <van-button
          class="loginbutton"
          round
          style="margin-top: 15px"
          @click="quit()"
          >返 回 首 页</van-button
        > -->
      </div>
      <!-- <div style="margin: 15px 10%; color: #1989fa" @click="enroll()">注册</div> -->
      <!-- <div>
        <img
          style="width: 50%; margin: 0px 25%"
          src="../../assets/erweima.jpg"
          alt=""
        />
        <div style="text-align: center; color: #ccc">扫描二维码进入小程序</div>
      </div> -->
    </div>
    <!-- 注册 二 -->
    <div class="logintopss" style="padding-bottom: 15px" v-if="enrollindex">
      <div style="font-size: 18px; color: #000; margin-top: 10px"></div>
      <div class="enrollfromstyle">
        <input
          type="text"
          v-model="enrollfrom.Name"
          placeholder="输入企业名称"
        />
        <input
          type="text"
          v-model="enrollfrom.LicCode"
          placeholder="营业执照编码"
        />
        <input
          type="text"
          v-model="enrollfrom.LoginName"
          placeholder="输入用户名"
        />
        <input
          type="password"
          v-model="enrollfrom.Password"
          placeholder="输入密码"
        />
        <input
          type="password"
          v-model="enrollfrom.RePassword"
          placeholder="再次输入密码"
        />
        <input
          type="text"
          v-model="enrollfrom.TouchTel"
          placeholder="输入用户手机号"
        />
        <div style="margin-top: 0px; position: relative">
          <input
            type="text"
            v-model="enrollfrom.Code"
            placeholder="输入短信验证码"
          />
          <button v-if="show" @click="ValidCodeRandom()" class="shortmsgons">
            获取短信验证码
          </button>
          <button v-if="!show" class="shortmsgons">
            {{ count }} 秒后重新获取
          </button>
        </div>
        <input
          type="text"
          @click="sexshow = true"
          v-model="enrollfrom.IsWithInName"
          placeholder="是否辖区内企业"
          readonly="readonly"
        />
        <van-popup v-model="sexshow" position="bottom" get-container="body">
          <van-picker
            show-toolbar
            :columns="sexlist"
            value-key="Name"
            @cancel="sexshow = false"
            @confirm="onConfirm"
          >
          </van-picker>
        </van-popup>
      </div>
      <div>
        <van-button
          class="loginbutton"
          round
          type="info"
          @click="RegisterOverfrom()"
          >提 交</van-button
        >
      </div>
      <div style="margin: 15px 10%; color: #1989fa" @click="loginindexshow">
        返回登录页面
      </div>
    </div>
  </div>
</template>
<script>
import { RE_Register, CheckStaffPeople } from "@/api/REplat";
import { SendValidedMsg } from "@/api/ResumeJS";
import { getstaffToken, setstaffToken } from "@/utils/auth";
import config from "@/config";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  data() {
    return {
      loginfrom: {
        //登录提交数据
        phone: "",
        password: "",
      },
      enrollfrom: {
        //注册
        IsWithIn: "", //是否辖区内企业、
        LicCode: "", //统一社会信用代码、
        Name: "", //企业名称，、
        LoginName: "", //管理员、
        TouchTel: "", //管理员手机号、
        Code: "", //短信验证码、
        Password: "", //登录密码
        ESort: 2,
      },
      enrollOnefrom: {
        //注册第一步
        ImgVerifier: "", //图片验证者，时间戳、
        ValidCode: "", //图片验证码、
        Mobile: "", //手机号、
        ShortMsg: "", //短信验证码;
      },
      yearofbirth: "", //时间
      loginindex: true, //登录页面
      enrollindex: false, //注册第二步
      enrollone: false, //注册第一步
      dateshow: false, //出生年月
      sexshow: false, //性别
      workingYearshow: false, //工作时间
      minDate: new Date(1970, 0), //
      maxDate: new Date(),
      sexlist: [
        { id: "1", Name: "是" },
        { id: "0", Name: "否" },
      ],
      show: true,
      count: "",
      timer: null,
    };
  },
  created() {
    // var token = getaccToken();
    // if (token != undefined) {
    //   this.$router.push("/list/company");
    // }
  },
  methods: {
    login() {
      //登录
      if (this.loginfrom.phone == "") {
        Toast("用户名不能为空");
        return false;
      }
      if (this.loginfrom.password == "") {
        Toast("密码不能为空");
        return false;
      }
      CheckStaffPeople(this.loginfrom).then((res) => {
        if (res.data.code == 0) {
          console.log(res.data);
          Toast.success("登录成功");
          console.log(res.data.data);
          setstaffToken(res.data.data);
          // 跳转到 另一个项目
          window.location.href =
            "https://workflow.anluoyun.cn/sign?userId=" +
            JSON.parse(getstaffToken()).userId +
            "&companyName=" +
            JSON.parse(getstaffToken()).companyName +
            "&companyId=" +
            JSON.parse(getstaffToken()).companyId +
            "&platformId=" +
            config.platformId1 +
            "&nickName=" +
            JSON.parse(getstaffToken()).userName;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    // 注册按钮
    enroll() {
      this.loginindex = false;
      this.enrollindex = true;
    },
    loginindexshow() {
      this.loginindex = true;
      this.enrollindex = false;
    },
    // 注册 第二步
    RegisterOverfrom() {
      if (this.enrollfrom.LicCode == "") {
        Toast.fail("请输入企业编码!");
        return false;
      }
      if (this.enrollfrom.Password == "") {
        Toast.fail("请输入登录密码!");
        return false;
      }
      if (this.enrollfrom.Password !== this.enrollfrom.RePassword) {
        Toast.fail("两次密码不同!");
        return false;
      }
      if (this.enrollfrom.Name == "") {
        Toast.fail("请输入企业名称!");
        return false;
      }
      if (this.enrollfrom.LoginName == "") {
        Toast.fail("请输入管理员!");
        return false;
      }
      if (this.enrollfrom.TouchTel == "") {
        Toast.fail("请输入管理员手机号!");
        return false;
      }
      // if (this.enrollfrom.Code == '') {
      //   Toast.fail('请输入短信验证码!')
      //   return false
      // }

      RE_Register(this.enrollfrom).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          Toast.success("注册成功!");
          this.loginindexshow();
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    // 获取短信验证码
    ValidCodeRandom() {
      if (this.enrollfrom.TouchTel == "") {
        Toast.fail("请输入手机号!");
        return false;
      }
      var MobileNum = this.enrollfrom.TouchTel;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        SendValidedMsg({ phone: MobileNum }).then((res) => {
          if (res.data.code == 0) {
            if (res.data.msg == "验证码获取太频繁，请稍后重试！") {
              Toast.fail(res.data.msg);
              this.show = true;
              return;
            }
            Toast.success("验证码已发送!");
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          } else {
            Toast.fail(res.data.msg);
          }
        });
      }
    },
    quit() {
      // window.history.go(-1)
      this.$router.go(-1);
      // this.$router.push("/list");
    },
    // 性别
    onConfirm(value, index) {
      console.log(value);
      this.sexshow = false;
      this.enrollfrom.IsWithIn = value.id;
      this.enrollfrom.IsWithInName = value.Name;
    },
    // 出生年月
    ondateConfirm(val) {
      this.enrollfrom.yearofbirth = this.dateformat(val);
      this.dateshow = false;
    },
    // 工作时间
    workingYeardate(val) {
      this.enrollfrom.workingYear = this.dateformat(val);
      this.workingYearshow = false;
    },
    // 日期格式化
    dateformat(val) {
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      return `${year}-${month}-${day}`;
    },
  },
};
</script>
<style scoped>
.firmlogin {
  background-image: url(../../assets/yuangongBgImage.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  min-height: 100%;
}
.logintopss {
  /* margin: 30px; */
  margin-top: 30vh;
  border-radius: 12px 12px 0 0;
  position: relative;
  background-color: white;
  min-height: 70vh;
}
.loginTitle {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 44px;
}
/* .logintopss div:nth-child(1){
    font-size: 24px;
    font-weight: 700;
} */
.logintopss div:nth-child(2) {
  margin-top: 15px;
  width: 80%;
  margin: auto;
  padding-top: 25px;
}
.logintopss div:nth-child(2) input {
  /* border-radius: 50px; */
  width: 100%;
  height: 50px;
  /* background: #e6e6e6; */
  margin: 8px 0px;
  /* padding-left: 35px; */
  color: #000;
  border: none;
  /* box-shadow: 1px 1px 1px #e6e6e6; */
  border-bottom: 1px solid #f6f7fb;
}
.logintopss div:nth-child(3) {
  margin-top: 15px;
}
.logintopss div:nth-child(3) .loginbutton {
  width: 80%;
  margin: 0 10%;
  font-size: 16px;
  font-weight: 400;
  height: 50px;
}
.logintopss .enrollfromstyle input {
  height: 30px !important ;
  margin: 7px 0px !important;
  background: #f6f7fb;
  border-radius: 50px;
  padding-left: 5px;
}
.shortmsgons {
  border: none;
  position: absolute;
  right: 0px;
  width: 130px;
  top: 5px;
  height: 33px;
  color: #188efb;
  font-size: 12px;
  background: transparent;
}
.imgcode {
  position: absolute;
  height: 32px;
  top: 196px;
  right: 32px;
  width: 90px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.firmbg {
  width: 100%;
  background-size: 100% 100%;
}
</style>
